import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";

export const CTASection = () => {
  const navigate = useNavigate();

  return (
    <section
      id="cta"
      className="py-24 px-6 bg-midnight relative overflow-hidden"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-midnight via-midnight to-vault-green/20 pointer-events-none" />

      <div className="container mx-auto max-w-3xl relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center"
        >
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-5 tracking-tight">
            Ready to see
            <br />
            your numbers?
          </h2>

          <p className="text-lg text-fog mb-10 max-w-xl mx-auto">
            Get in touch and we'll have you inside Dollar Bill within 24 hours.
          </p>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.2 }}
          >
            <Button
              size="lg"
              onClick={() => navigate("/contact")}
              className="bg-vault-green hover:bg-vault-green/90 text-white text-base px-10 py-6 rounded-lg shadow-lg hover:shadow-xl transition-all"
            >
              Get Started
              <ArrowRight className="ml-2 h-4 w-4" />
            </Button>
          </motion.div>

          <motion.p
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ delay: 0.5 }}
            className="text-sm text-fog/50 mt-6"
          >
            Questions?{" "}
            <a
              href="mailto:hello@askdollarbill.com"
              className="text-vault-green hover:text-vault-green/80 transition-colors"
            >
              hello@askdollarbill.com
            </a>
          </motion.p>
        </motion.div>
      </div>
    </section>
  );
};
